import Report from '../../../views/Student/report/Report.student.view'

export default Report;